import { Appointment } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";

export default async function postRedeemPackage({
  aid,
  inclusion_ids = [],
}: {
  aid: Appointment["aid"];
  inclusion_ids: number[];
}): Promise<{
  success: boolean;
  error?: string;
}> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const headers = new Headers();

    headers.append("accept", "application/json");
    headers.append("Content-Type", "application/json");

    const body = JSON.stringify({
      inclusion_ids,
    });

    const requestOptions: RequestInit = {
      method: "POST",
      body,
      headers,
      credentials: "include",
    };

    const response = await fetch(
      `${TRYST_HOST}/appointment/${aid}/package/redeem`,
      requestOptions
    );

    const resp = await response.json();
    return resp;
  } catch (error) {
    console.error("ERROR =====> postRedeemPackage", error);
    return { success: false };
  }
}
